import { css } from 'styled-components';
import color from '../../../styles/colors';

export const coloredGreen = css`
    background: ${color.greenForestLight};
    color: ${color.green};
`;

export const coloredGreenDark = css`
    background: ${color.greenForestDark};
    color: ${color.white};
`;

export const coloredRed = css`
    background: ${color.redLight};
    color: ${color.red};
`;

export const coloredRedDark = css`
    background: ${color.redDark};
    color: ${color.white};
`;

export const coloredGrey = css`
    background: ${color.blueSkyLight};
    color: ${color.blueDark};
`;

export const coloredGrayDark = css`
    background: ${color.grey};
    color: ${color.white};
`;

export const coloredYellow = css`
    background: ${color.yellowLight};
    color: ${color.yellow};
`;

export const coloredYellowDark = css`
    background: ${color.yellowDark};
    color: ${color.white};
`;

export const coloredBlue = css`
    background: ${color.blueCloud};
    color: ${color.blueSkyDark};
`;

export const coloredBlueDark = css`
    background: ${color.blueCloudDark};
    color: ${color.white};
`;

export const coloredPurple = css`
    background: ${color.purpleLight};
    color: ${color.purple};
`;

export const coloredPurpleDark = css`
    background: ${color.purpleDark};
    color: ${color.white};
`;

export const coloredPink = css`
    background: ${color.pinkLight};
    color: ${color.pink};
`;

export const coloredPinkDark = css`
    background: ${color.pinkDark};
    color: ${color.white};
`;

export const coloredBlueLight = css`
    background: ${color.blueLight3};
    color: ${color.blue};
`;
